/* -------------------------------------------------------------------------------------------------
 * Default Values
 * -----------------------------------------------------------------------------------------------*/

export const DEFAULT_COLOR = "#006FEE";
export const DEFAULT_COLOR_OKLCH = "oklch(0.6199 0.194 253.67)";
export const DEFAULT_COLOR_HSL = "hsl(253.67, 100%, 61.99%)";

export const SWATCHES_PER_PAGE = 8;

/* -------------------------------------------------------------------------------------------------
 * Default Color Swatches
 * -----------------------------------------------------------------------------------------------*/

export const defaultSwatches = [
  "hsla(338, 77%, 78%, 1)", // Pink
  "hsla(309, 23%, 55%, 1)", // Muted purple
  "hsla(355, 85%, 66%, 1)", // Coral/red
  "hsla(16, 100%, 67%, 1)", // Orange
  "hsla(47, 92%, 66%, 1)", // Yellow
  "hsla(152, 80%, 56%, 1)", // Green
  "hsla(197, 59%, 64%, 1)", // Blue
  "hsla(220, 13%, 18%, 1)", // Dark slate (backgrounds)
  "hsla(220, 70%, 50%, 1)", // Royal blue
  "hsla(210, 100%, 56%, 1)", // Bright blue
  "hsla(180, 100%, 25%, 1)", // Teal
  "hsla(170, 50%, 65%, 1)", // Seafoam
  "hsla(150, 60%, 75%, 1)", // Mint green
  "hsla(280, 60%, 60%, 1)", // Violet
  "hsla(270, 50%, 70%, 1)", // Lavender
  "hsla(350, 100%, 88%, 1)", // Blush
];
